import { render, staticRenderFns } from "./RefundTicketInterface.vue?vue&type=template&id=6de9033a&scoped=true"
import script from "./RefundTicketInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefundTicketInterface.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RefundTicketInterface.vue?vue&type=style&index=0&id=6de9033a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9033a",
  null
  
)

export default component.exports